<template>
  <a-modal title="是否更新物流信息" class="update-logistics-module" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="update-logistics-box">
          <span>提示，确认更新后，将在单据-过账单据的对应销售
出库单中更新此信息。</span>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: "updateLogisticsModule",
  components: {},
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    onCofrim() {
      this.visible = false;
      this.$emit("btnUpdateLogistics");
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.update-logistics-module {
  width: 520px !important;
  .update-logistics-box {
    display: flex;
    justify-content: center;
    padding: 0 80px 40px 80px;
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 48px 0;
  }
}
</style>
